const cards = [
  {
    title: '本周必看 · 编辑精选十部佳作',
    tag: '编辑推荐',
    img: 'https://readdy.ai/api/search-image?query=Warm%20abstract%20editorial%20composition%20with%20coral%20orange%20and%20deep%20charcoal%20gradient%2C%20floating%20geometric%20shapes%20with%20soft%20shadows%2C%20clean%20modern%20magazine%20spread%20aesthetic%2C%20sophisticated%20minimalist%20design%2C%20no%20text&width=640&height=420&seq=card-01&orientation=landscape',
    desc: '编辑团队从本周更新的海量内容中精挑细选，涵盖剧情、喜剧、悬疑等多种类型。',
  },
  {
    title: '夏日观影季 · 清凉片单来了',
    tag: '专题合集',
    img: 'https://readdy.ai/api/search-image?query=Elegant%20abstract%20visual%20with%20warm%20amber%20and%20teal%20color%20blocks%2C%20layered%20translucent%20rectangles%20intersecting%20organically%2C%20soft%20gradient%20transitions%2C%20contemporary%20digital%20art%2C%20clean%20editorial%20style%2C%20no%20text&width=640&height=420&seq=card-02&orientation=landscape',
    desc: '精选多部适合夏日观看的轻松内容，从搞笑综艺到治愈纪录片一应俱全。',
  },
  {
    title: '高分纪录片榜单 · 9分以上神作',
    tag: '评分榜单',
    img: 'https://readdy.ai/api/search-image?query=Modern%20abstract%20art%20with%20warm%20coral%20and%20dark%20teal%20gradients%2C%20flowing%20curved%20shapes%20with%20subtle%20glow%2C%20minimal%20geometric%20composition%2C%20editorial%20magazine%20design%20feel%2C%20clean%20sophisticated%20aesthetic%2C%20no%20text&width=640&height=420&seq=card-03&orientation=landscape',
    desc: '收录全网评分9分以上的纪录片作品，每一部都值得你花时间细细品味。',
  },
  {
    title: '新番速递 · 七月新番全收录',
    tag: '追番指南',
    img: 'https://readdy.ai/api/search-image?query=Artistic%20abstract%20composition%20with%20vibrant%20warm%20orange%20and%20muted%20teal%20shapes%2C%20overlapping%20circles%20and%20soft%20gradients%2C%20contemporary%20digital%20art%20style%2C%20clean%20background%20with%20subtle%20texture%2C%20no%20text%20or%20letters&width=640&height=420&seq=card-04&orientation=landscape',
    desc: '七月最新番剧已全部收录，从热血战斗到日常治愈，追番日历一目了然。',
  },
  {
    title: '经典回顾 · 那些年我们追过的剧',
    tag: '怀旧专题',
    img: 'https://readdy.ai/api/search-image?query=Warm%20nostalgic%20abstract%20visual%20with%20soft%20coral%20and%20deep%20charcoal%20tones%2C%20layered%20geometric%20shapes%20with%20gentle%20transitions%2C%20vintage%20editorial%20feel%2C%20clean%20minimal%20composition%2C%20no%20text&width=640&height=420&seq=card-05&orientation=landscape',
    desc: '回顾过去十年间最令人难忘的经典剧集，每部都承载着满满的回忆。',
  },
  {
    title: '体育盛宴 · 赛事精彩回放',
    tag: '体育频道',
    img: 'https://readdy.ai/api/search-image?query=Dynamic%20abstract%20composition%20with%20warm%20coral%20and%20teal%20energy%2C%20bold%20geometric%20shapes%20intersecting%20with%20movement%2C%20modern%20sports%20editorial%20aesthetic%2C%20clean%20minimalist%20design%2C%20no%20text%20or%20typography&width=640&height=420&seq=card-06&orientation=landscape',
    desc: '近期各大体育赛事精彩回放与集锦，不错过每一个激动人心的瞬间。',
  },
  {
    title: '深夜食堂 · 美食纪录片精选',
    tag: '美食专题',
    img: 'https://readdy.ai/api/search-image?query=Warm%20inviting%20abstract%20art%20with%20rich%20coral%20and%20amber%20gradients%2C%20soft%20organic%20shapes%20suggesting%20culinary%20warmth%2C%20elegant%20editorial%20photography%20style%2C%20clean%20minimal%20background%2C%20no%20text&width=640&height=420&seq=card-07&orientation=landscape',
    desc: '精选国内外美食纪录片，从街头小吃到米其林后厨，一场视觉味觉的双重盛宴。',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
            精彩推荐
          </h2>
          <p className="mt-3 text-foreground-500 text-sm md:text-base">
            编辑团队为你打造的精品内容合集
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {cards.map((card, i) => (
            <div
              key={i}
              className={`group bg-background-100 rounded-xl overflow-hidden cursor-default transition-all duration-300 hover:-translate-y-1 ${
                i === 0 ? 'sm:col-span-2 lg:col-span-2 lg:row-span-1' : ''
              }`}
            >
              <div className="relative aspect-[3/2] overflow-hidden">
                <img
                  src={card.img}
                  alt={card.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute top-3 left-3 px-3 py-1 rounded-full bg-black/60 text-white text-xs font-medium whitespace-nowrap">
                  {card.tag}
                </span>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="text-sm md:text-base font-bold text-foreground-900">
                  {card.title}
                </h3>
                <p className="mt-2 text-xs md:text-sm text-foreground-500 leading-relaxed line-clamp-2">
                  {card.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}